import { AiChatContext } from '@fb/models';

/** Page size for the /v1/chats paginated list. */
export const AI_CHATS_PAGE_SIZE = 50;

export const AI_CHAT_SEND_PENDING_TIMEOUT_MS = 10_000;

/** Max length (incl. spaces) for the optional answer-feedback comment. */
export const FEEDBACK_COMMENT_MAX_LENGTH = 1000;

/** Distance (px) from the newest messages within which the full-page view stays pinned to bottom. */
export const AI_CHAT_SCROLL_BOTTOM_THRESHOLD_PX = 50;

/** Backend default until `POST /chats/{chatId}/title` assigns a generated title. */
export const DEFAULT_CHAT_TITLE = 'New chat';

export const AI_CHAT_DEFAULT_GREETING_LANG = 'en' as const;

export const AI_CHAT_DEFAULT_CONTEXT = AiChatContext.Personal;

/** URL path segment per context (not the same strings as API `context`). */
export const AI_CHAT_ROUTE_SEGMENT: Record<AiChatContext, string> = {
  [AiChatContext.Personal]: 'for-me',
  [AiChatContext.Work]: 'for-work',
} as const;

/** Host shell base path for AI chat routes. */
export const AI_CHAT_SHELL_CHAT_BASE_PATH = '/ai-bot/chat';

export function aiChatShellPath(context: AiChatContext): string {
  return `${AI_CHAT_SHELL_CHAT_BASE_PATH}/${AI_CHAT_ROUTE_SEGMENT[context]}`;
}

/** SessionStorage key isolated from the previous ChatBot version. */
export const AI_CHAT_LAST_TAB_SESSION_KEY = 'pt-ai-chat-v2-last-context';

/** Question textarea min height (px). */
export const AI_CHAT_QUESTION_TEXTAREA_MIN_HEIGHT_PX = 40;

/** Question textarea max height (px). */
export const AI_CHAT_QUESTION_TEXTAREA_MAX_HEIGHT_PX = 160;

/** CSS custom props on `pu-ai-chat-form` (used from SCSS). */
export const AI_CHAT_QUESTION_TEXTAREA_MIN_HEIGHT_VAR =
  '--fb-chat-question-textarea-min-h' as const;

export const AI_CHAT_QUESTION_TEXTAREA_MAX_HEIGHT_VAR =
  '--fb-chat-question-textarea-max-h' as const;
